var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F05BBF66-68AA-44FD-8313-0912B00E7C17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VHR-UI-Oct-21---Built-by-US",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Owners_NA_Vehicle-Healthview_1.1",
    transform: "translate(-387.000000, -2983.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 1440,
    height: 5301
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget-/-Ford-Dealer-/-Web-Copy",
    transform: "translate(-1.000000, 2861.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1441,
    height: 335
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    fill: "#00095B",
    transform: "translate(361.999483, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Symbol-Sets-/-16x16",
    transform: "translate(26.000517, 106.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-3",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55744611,0 C10.5668953,0.187957642 12.7144133,2.23522578 13,6.14180442 C12.868955,9.06851224 10.721437,12.3545774 6.55744611,16 C2.59908377,12.6997091 0.413268403,9.41364387 0,6.14180442 C0.149704252,2.04726814 2.33551962,0 6.55744611,0 Z M6.5,4 C5.11928813,4 4,5.11928813 4,6.5 C4,7.88071187 5.11928813,9 6.5,9 C7.88071187,9 9,7.88071187 9,6.5 C9,5.11928813 7.88071187,4 6.5,4 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.48e11686ee9208bc8ffeecad7c3d5928.svg";
export { ForwardRef as ReactComponent };